import { createApi } from '@reduxjs/toolkit/query/react'
import { MDT_ARCHIVE, MDT_ASSESSMENT_LIST, MDT_ASSESSMENT_STATUS_UPDATE, MDT_ASSESSMENT_UPDATE, MDT_ASSESSMENT_VIEW, MDT_ASSIGN_ASSESSMENT_DATES, MDT_ASSIGN_CHECKLIST, MDT_CHECKLIST_UPDATE, MDT_DELETE_ASSESSMENT_DATE } from "config/apiPaths"
import { RTK_CACHE_EXPIRATION } from "config/constants";
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const mdtAssessmentApi = createApi({
    reducerPath: 'mdtAssessmentApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/mdt",
    }),
    tagTypes: ["mdtAssessmentList", "mdtAssessmentDetails"],
    keepUnusedDataFor: RTK_CACHE_EXPIRATION,
    endpoints: (builder) => ({

        // get mdt assessment list
        getMdtAssessmentList: builder.query({
            query: ({ search = "", status = "", client_type = "", mdtStatus = "", startDate = "", endDate = "", specialization = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: MDT_ASSESSMENT_LIST,
                data: { search, status, client_type: client_type?.value, mdtStatus: mdtStatus?.value, startDate, endDate, page, limit, sort, specialization: specialization?.value }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["mdtAssessmentList"]
        }),

        // update assessment status
        updateAssesmentStatus: builder.mutation({
            query: ({ caseLoadId, statusId }) => ({
                method: "PUT",
                url: `${MDT_ASSESSMENT_STATUS_UPDATE}/${caseLoadId}/${statusId}`
            }),
            invalidatesTags: ["mdtAssessmentList", "mdtAssessmentDetails"]
        }),

        // create assessment
        getMdtAssessmentDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MDT_ASSESSMENT_VIEW}/${id}`

            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["mdtAssessmentDetails"]
        }),

        // assessment check list status
        assignCheckList: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MDT_ASSIGN_CHECKLIST,
                data
            }),
            invalidatesTags: ["mdtAssessmentDetails"]
        }),

        // update assessment details
        updateAssesment: builder.mutation({
            query: ({ assessmentId, data }) => ({
                method: "PUT",
                url: `${MDT_ASSESSMENT_UPDATE}/${assessmentId}`,
                data
            }),
            invalidatesTags: ["mdtAssessmentList", "mdtAssessmentDetails"]
        }),

        // update checklist status
        updateCheckListStatus: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MDT_CHECKLIST_UPDATE}/${id}`,
                data
            }),
            invalidatesTags: ["mdtAssessmentDetails"]
        }),

        assignAssessmentDates: builder.mutation({
            query: ({ caseloadTherapistId, assessment_dates }) => ({
                method: "POST",
                url: `${MDT_ASSIGN_ASSESSMENT_DATES}/${caseloadTherapistId}`,
                data: { assessment_dates }
            }),
            invalidatesTags: ["mdtAssessmentDetails"]
        }),

        deleteAssessmentDate: builder.mutation({
            query: (assessmentDateId) => ({
                method: "DELETE",
                url: `${MDT_DELETE_ASSESSMENT_DATE}/${assessmentDateId}`
            }),
            invalidatesTags: ["mdtAssessmentDetails"]
        }),

        archiveAssessment: builder.mutation({
            query: ({ id }) => ({
                method: "DELETE",
                url: `${MDT_ARCHIVE}/${id}`,
                // data
            }),
            invalidatesTags: ["mdtAssessmentDetails", "mdtAssessmentList"]
        }),
    }),
})

export const {
    useGetMdtAssessmentListQuery,
    useUpdateAssesmentStatusMutation,
    useGetMdtAssessmentDetailsQuery,
    useAssignCheckListMutation,
    useUpdateAssesmentMutation,
    useUpdateCheckListStatusMutation,
    useAssignAssessmentDatesMutation,
    useDeleteAssessmentDateMutation,
    useArchiveAssessmentMutation

} = mdtAssessmentApi;
